import { StyledSeparator } from './styled';
export function MenuDivider() {
    return <StyledSeparator />;
}
